module.exports = __webpack_public_path__ + "img/notice.87115291.png";